import { createFileRoute } from '@tanstack/react-router';

import { rightPaneEnabledAtom } from '@/components/right-pane/right-pane.state';
import { jotaiStore } from '@/providers/jotai/jotai-store';
import UserStateAtoms from '@/state/user.state';
import { resolveFacilityFromParams } from '@/utils/facility-resolver';
import { createMigrationRouteGuard } from '@/utils/route-guards/migration-guard';

export const Route = createFileRoute('/$org/$agent/coincident-peaks')({
  beforeLoad: (ctx) => {
    createMigrationRouteGuard('coincident-peaks')(ctx);
    jotaiStore.set(rightPaneEnabledAtom, false);
  },
  loader: ({ params }) => {
    const userState = jotaiStore.get(UserStateAtoms.user);
    const { agentId } = resolveFacilityFromParams(params, userState);
    return { agentId };
  },
});
